/* sc-pdp-mobile-gallery-fade.js — Fade-mode slider (tham khảo LIVE Flickity).
 *
 * LIVE theme (192858882392) dùng Flickity với `fade: true` trên mobile PDP
 * gallery → slides stack absolute, crossfade giữa active/inactive. KHÔNG
 * có horizontal scroll → zero peek.
 *
 * Shrine gốc dùng native `overflow-x: auto` + CSS scroll-snap → iOS Safari
 * peek 15% slide kế dù đã lock widths (3 attempts fail).
 *
 * Fix: replicate Flickity fade mode bằng vanilla JS + CSS. Disable native
 * scroll, stack slides absolute, swipe gesture → switch active class →
 * crossfade. Integrate với vendor `media-gallery.setActiveMedia` để
 * Customily canvas + variant selection sync.
 *
 * Scope: mobile only. Self-disable nếu có vendor override.
 */
(function () {
  'use strict';

  if (matchMedia('(min-width: 750px)').matches) return;

  var SWIPE_THRESHOLD = 40; // px — min horizontal movement để đổi slide
  var SWIPE_VERT_MAX = 60;  // px — max vertical movement trước khi reject (cho phép scroll dọc)

  function init() {
    var gallery = document.querySelector('media-gallery');
    var ul = gallery && gallery.querySelector('ul.product__media-list');
    if (!ul) return;
    var items = Array.from(ul.querySelectorAll('.product__media-item'));
    if (items.length < 2) return;

    /* Mark UL + items với class để CSS fade rule target. CSS khai báo trong
     * sc-pdp-overrides.css (mobile scope). */
    ul.classList.add('sc-fade-slider');

    /* Resolve nav buttons SỚM — setActive() dưới tham chiếu prevBtn/nextBtn
     * qua updateNavVisibility. Declare trước initial setActive call. */
    var sliderComp = gallery.querySelector('slider-component') || gallery;
    var prevBtn = sliderComp.querySelector('button[name="previous"]');
    var nextBtn = sliderComp.querySelector('button[name="next"]');

    var activeIdx = 0;
    /* Pick initial active slide: slide có class `is-active` (vendor initial state)
     * hoặc first. Vendor không dùng aria-hidden cho slide active tracking. */
    items.forEach(function (it, i) {
      if (it.classList.contains('is-active')) activeIdx = i;
    });
    setActive(activeIdx, false);

    function setActive(idx, animate) {
      idx = Math.max(0, Math.min(items.length - 1, idx));
      activeIdx = idx;
      items.forEach(function (it, i) {
        if (i === idx) {
          it.classList.add('sc-fade-active');
        } else {
          it.classList.remove('sc-fade-active');
        }
      });
      updateHeight(idx);
      updateCounter(idx);
      updateNavDisabledState(idx);
      syncThumbnail(idx);
    }

    /* Adaptive height: UL co/dãn theo active slide .media natural height.
     * Canvas slide (85svh) to hơn image slide (square = 100vw). Grid stack
     * default lấy MAX → UL luôn 85svh → image slide có gap dọc lớn.
     * Fix: set explicit ul.height = active media height. Overflow hidden trên UL
     * clip slides khác (canvas vẫn 85svh để Fabric render đúng, chỉ bị clip). */
    function updateHeight(idx) {
      var active = items[idx];
      if (!active) return;
      var media = active.querySelector('.media');
      if (!media) return;
      var h = media.getBoundingClientRect().height;
      /* setProperty với 'important' — CSS rule `.sc-fade-slider { height: auto !important }`
       * sẽ đè inline style thường. Phải match !important để inline thắng cascade. */
      if (h > 0) ul.style.setProperty('height', h + 'px', 'important');
    }

    /* JS-toggle class `.sc-has-canvas` thay thế CSS `:has()` selector — widely
     * supported all browsers (iOS Safari < 15.4 không support `:has()`).
     * Watch canvas-container.op-zero toggle → add/remove class trên slide → CSS
     * rule `.sc-has-canvas .media { height: 85svh }` apply reliably. */
    var _canvasSyncing = false;
    function syncCanvasClass() {
      if (_canvasSyncing) return;
      _canvasSyncing = true;
      items.forEach(function (it) {
        var canvas = it.querySelector('.cl-canvas-container .canvas-container');
        var shouldHave = canvas && !canvas.classList.contains('op-zero');
        var currentlyHas = it.classList.contains('sc-has-canvas');
        if (shouldHave && !currentlyHas) it.classList.add('sc-has-canvas');
        else if (!shouldHave && currentlyHas) it.classList.remove('sc-has-canvas');
      });
      updateHeight(activeIdx);
      /* Release flag async — microtask để MutationObserver callback queue clear
       * trước khi cho phép syncCanvasClass gọi lại. */
      setTimeout(function () { _canvasSyncing = false; }, 50);
    }
    syncCanvasClass();

    /* ResizeObserver: canvas Customily render xong (bitmap load async) hoặc
     * op-zero toggle → .media height changes → re-measure active slide. */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        updateHeight(activeIdx);
      });
      items.forEach(function (it) {
        var media = it.querySelector('.media');
        if (media) ro.observe(media);
      });
    }

    /* MutationObserver watch mỗi slide (subtree) cho:
     *   - Customily thêm .cl-canvas-container lazy (DOM childList change)
     *   - canvas-container.op-zero toggle (attributes class change)
     * Filter: skip mutations target LÀ item hoặc canvas overlay container gốc
     * (các class change này do chúng ta add/remove → recursion). */
    var canvasMo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        /* Skip class changes on item itself — đó là .sc-has-canvas toggle của ta. */
        if (m.type === 'attributes' && items.indexOf(m.target) >= 0) continue;
        syncCanvasClass();
        return;
      }
    });
    items.forEach(function (it) {
      canvasMo.observe(it, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
        childList: true
      });
    });

    /* Keep the same disabled contract as Shrine's native SliderComponent while
     * fade mode owns the slide index. The controls stay visible and dim at the
     * boundaries instead of disappearing. */
    function setNavDisabled(button, disabled) {
      if (!button) return;
      button.classList.remove('sc-nav-edge');
      if (button.disabled !== disabled) button.disabled = disabled;
      if (disabled) {
        if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
      } else if (button.hasAttribute('aria-disabled')) {
        button.removeAttribute('aria-disabled');
      }
    }

    function updateNavDisabledState(idx) {
      setNavDisabled(prevBtn, idx === 0);
      setNavDisabled(nextBtn, idx === items.length - 1);
    }

    /* Vendor SliderComponent tính currentPage = round(scrollLeft / itemOffset).
     * Fade mode overflow:hidden → itemOffset=0 → NaN / -Infinity. Override
     * manual: set textContent counter `.slider-counter--current` = idx+1. */
    function updateCounter(idx) {
      var cur = gallery.querySelector('.slider-counter--current');
      var total = gallery.querySelector('.slider-counter--total');
      if (cur) cur.textContent = idx + 1;
      if (total) total.textContent = items.length;
    }

    function syncThumbnail(idx) {
      if (!gallery.setActiveMedia) return;
      var mediaId = items[idx].dataset.mediaId;
      if (!mediaId) return;
      try {
        /* Set flag để tránh recursion: vendor setActiveMedia toggle `is-active`
         * class → MutationObserver fire → setActive → syncThumbnail infinite loop. */
        ul._scFadeSyncing = true;
        gallery.setActiveMedia(mediaId);
        setTimeout(function () { ul._scFadeSyncing = false; }, 50);
      } catch (e) { ul._scFadeSyncing = false; }
    }

    /* Nav buttons (prev/next): vendor call slider.scrollTo → fade mode
     * overflow:hidden → scrollTo no-op → không đổi slide. Intercept click,
     * gọi setActive trực tiếp. Dùng capture + stopImmediatePropagation để
     * chặn vendor handler trước. (prevBtn/nextBtn đã declare ở trên.) */
    function navClick(dir) {
      return function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var next = activeIdx + dir;
        if (next < 0) next = 0;
        if (next > items.length - 1) next = items.length - 1;
        setActive(next, true);
      };
    }
    if (prevBtn) prevBtn.addEventListener('click', navClick(-1), true);
    if (nextBtn) nextBtn.addEventListener('click', navClick(1), true);

    /* Vendor SliderComponent can recompute from the zero-width fade track and
     * write the wrong disabled attribute. Re-assert the authoritative fade
     * index after such a write instead of stripping both boundaries open. */
    var navMo = new MutationObserver(function () {
      updateNavDisabledState(activeIdx);
    });
    if (prevBtn) navMo.observe(prevBtn, { attributes: true, attributeFilter: ['disabled'] });
    if (nextBtn) navMo.observe(nextBtn, { attributes: true, attributeFilter: ['disabled'] });

    /* Touch handler: detect horizontal swipe. Vertical drag → không handle
     * → browser native scroll document. */
    var touchStartX = 0, touchStartY = 0, touchActive = false;
    ul.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchActive = true;
    }, { passive: true });

    ul.addEventListener('touchend', function (e) {
      if (!touchActive) return;
      touchActive = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - touchStartX;
      var dy = t.clientY - touchStartY;
      if (Math.abs(dy) > SWIPE_VERT_MAX) return; // vertical scroll intent
      if (Math.abs(dx) < SWIPE_THRESHOLD) return; // tap or tiny drag
      if (dx < 0) setActive(activeIdx + 1, true); // swipe left → next
      else setActive(activeIdx - 1, true);        // swipe right → prev
    }, { passive: true });

    ul.addEventListener('touchcancel', function () { touchActive = false; }, { passive: true });

    /* Vendor buttons (arrows, thumbnails) call setActiveMedia → scrollTo UL.
     * Intercept scroll events để detect external change và sync active index. */
    ul.addEventListener('scroll', function () {
      if (ul._scFadeSyncing) return;
      /* Vendor setActiveMedia scrollTo({left: activeMedia.offsetLeft}).
       * Với fade mode, slides absolute stacked → offsetLeft = 0 cho tất cả.
       * Nhưng nếu user somehow scroll, detect và reset về active. */
      if (ul.scrollLeft !== 0) ul.scrollLeft = 0;
    }, { passive: true });

    /* MutationObserver detect khi vendor setActiveMedia toggle `is-active` class
     * trên slide (thumbnail click, nav button click) → sync fade state.
     * Vendor media-gallery.js line 42-45 chỉ toggle class, KHÔNG touch aria-hidden. */
    var mo = new MutationObserver(function (muts) {
      if (ul._scFadeSyncing) return; // skip khi chính mình đang set (recursion guard)
      muts.forEach(function (m) {
        if (m.attributeName !== 'class') return;
        var el = m.target;
        if (el.classList.contains('is-active')) {
          var i = items.indexOf(el);
          if (i >= 0 && i !== activeIdx) setActive(i, true);
        }
      });
    });
    items.forEach(function (it) {
      mo.observe(it, { attributes: true, attributeFilter: ['class'] });
    });

    /* Re-sync height on viewport/orientation change. */
    window.addEventListener('resize', function () { setActive(activeIdx, false); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
